export const GB_FEATURES = {
  EXP_MINI_APP_INQUIRY_ENGAGEMENT: 'exp_mini_app_inquiry_engagement',
  EXP_PUPPY_PAGE: 'exp_puppy_page',
  EXP_SEARCH_RESULTS_LAYOUT_V2: 'exp_search_results_layout_v2',
  EXP_SEARCH_INFINITE_SCROLL_V2: 'exp_search_infinite_scroll_v2',
  EXP_SEARCH_FILTERS_BTN: 'exp_search_filters_btn',
  EXP_PUPPY_CARD_V2: 'exp_puppy_card_v2'
};
